<style scoped></style>

<template>
  <div class="flex flex-col mt-4">
    <div class="overflow-x-auto">
      <div
        class="relative align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
      >
        <div
          v-if="selectedRespondents.length > 0"
          class="absolute top-0 left-12 flex h-12 w-full items-center space-x-3 bg-gray-50 sm:left-16"
        >
          <button
            type="button"
            class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            @click="onRemind"
          >
            {{ $t('respondents.remember') }}
          </button>
          <button
            type="button"
            class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            @click="onDelete"
          >
            {{ $t('respondents.remove') }}
          </button>
        </div>
        <table class="min-w-full">
          <thead>
            <tr class="h-12">
              <th
                class="relative w-12 px-6 border-b border-gray-200 bg-gray-50"
              >
                <input
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
                  @change="
                    selectedRespondents = $event.target.checked
                      ? respondents
                          .filter((r) => !r.has_responded)
                          .map((r) => r.id)
                      : []
                  "
                  :checked="
                    respondents.length > 0 &&
                    selectedRespondents.length === respondents.length
                  "
                />
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                {{ $t('respondents.full_name') }}
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                {{ $t('respondents.email') }}
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                {{ $t('respondents.phone_number') }}
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                {{ $t('respondents.entered') }}
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              >
                {{ $t('respondents.latest_post') }}
              </th>
              <th
                class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="respondent.id"
              v-for="(respondent, count) in respondents"
              :class="{
                'bg-gray-50': count % 2 !== 0,
                'bg-white': count % 2 === 0,
              }"
            >
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                <input
                  type="checkbox"
                  class="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
                  v-model="selectedRespondents"
                  :value="respondent.id"
                />
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                {{ respondent.full_name }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                {{ respondent.email }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                {{ respondent.phone }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                <span
                  v-if="respondent.has_responded"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                >
                  {{ $t('respondents.entered') }}
                </span>
                <span
                  v-if="!respondent.has_responded"
                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                >
                  {{ $t('respondents.not_filled_in') }}
                </span>
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                {{ parseDateTime(respondent.last_notification) }}
              </td>
              <td
                class="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium"
              >
                <a
                  :href="`/forms/${form.id}/introduction/${respondent.code}`"
                  class="text-indigo-600 hover:text-indigo-900 pr-8"
                  target="_blank"
                >
                  {{ $t('respondents.link') }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { parseISO } from 'date-fns';
import { nl } from 'date-fns/locale';

export default {
  name: 'RespondentList',
  components: {},
  data() {
    return {
      selectedRespondents: [],
    };
  },
  methods: {
    parseDateTime(input) {
      return parseISO(input, {
        locale: nl,
      }).toLocaleString();
    },
    async onRemind() {
      if (!confirm(this.$t('respondents.delete_respondent'))) {
        return;
      }

      try {
        await Promise.all(
          this.selectedRespondents.map((respondentId) => {
            return fetch(`/respondents/${respondentId}/remind`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': this.csrftoken,
              },
            });
          }),
        );
      } catch (err) {
        console.error('Not all respondents reminded', err);
      }

      location.reload();
    },
    async onDelete() {
      if (!confirm('Weet je zeker dat je deze respondenten wil verwijderen?')) {
        return;
      }

      try {
        await Promise.all(
          this.selectedRespondents.map((respondentId) => {
            return fetch(`/respondents/${respondentId}/delete`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': this.csrftoken,
              },
            });
          }),
        );
      } catch (err) {
        console.error('Not all respondents reminded', err);
      }

      location.reload();
    },
  },
  computed: {},
  props: {
    respondents: Array,
    form: Object,
    csrftoken: String,
  },
};
</script>
